module.exports = __webpack_public_path__ + "static/media/Gmc_Blanc.15dd4b85.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Img/Gmc_Blanc.svg
// module id = 107
// module chunks = 0